import React from 'react'
import Icon from './Icons'

class HeaderPhone extends React.Component{

  render() {   

    return(
		  <div className='headerPhone'>    
		    <Icon iconName='plickers-logo' />    
		  </div>    
		)
	}
}

export default HeaderPhone
